import * as Constants from '../constants/actions';
import { Filters, ModifyDate, Decades} from '../utilities';
/** 
 * Changes to this object should be few and far between. Edit with extreme caution.
 * @constant 
 * @name INITIAL_STATE
 * @type {Object}
 * @default
*/
const INITIAL_STATE = {
		allPublications: [],
		publications: [],
		sort: -1,
		filter: undefined,
		decades:[]
};

const archives = ( state = INITIAL_STATE, action ) => {

	switch( action.type ){
    case Constants.GET_PUBLICATIONS:
			let publications, decades;			
			if ( action.payload.publications ) {
				publications = action.payload.publications.map( ModifyDate );
				decades = Decades( action.payload.publications );
			}
			return { ...state,allPublications: publications, publications: publications || [], decades };
		case Constants.SORT:
			let sortedPublications = Filters( [...state.allPublications], action.payload.sort, state.filter);
			return { ...state, publications: sortedPublications, sort: action.payload.sort };
		case Constants.FILTER:
			let filteredPublications = Filters( [...state.allPublications], state.sort, action.payload.filter);
			return { ...state, publications: filteredPublications, filter: action.payload.filter};
		default:
			return state;
	}
}

export default archives;